import React, { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { ProtectedRoute } from '@components';
import ResignationFeatureRoute from './featureRoute';

const ResignationList = lazy(() => import('./list'));
const ResignationCreate = lazy(() => import('./create'));

export default {
  path: 'resignation',
  element: <ResignationFeatureRoute component={<Outlet />} />,
  children: [
    {
      index: true,
      element: <ProtectedRoute title="离职申请" component={<ResignationList />} />,
    },
    {
      path: 'create',
      element: <ProtectedRoute title="提交离职申请" component={<ResignationCreate />} />,
    },
  ],
};
